(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/components/buttons-block.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/components/buttons-block.js');
"use strict";

const _React = React,
  useContext = _React.useContext;
const Button = svs.ui.ReactButton;
const Icon = svs.ui.ReactIcon;
const FAVORITE_MAX_SIZE = 1000; 

const resetFavoriteCategoryGames = (categories, orgFavorites) => categories.reduce((acc, category) => {
  var _category$gameList;
  if ((_category$gameList = category.gameList) !== null && _category$gameList !== void 0 && (_category$gameList = _category$gameList.config) !== null && _category$gameList !== void 0 && _category$gameList.favoriteTickets) {
    category.games = orgFavorites;
  }
  acc.push(category);
  return acc;
}, []);
const addFavoriteGameWithSizeLimit = (games, newGame) => {
  const currentGameCodes = games.map(_ref => {
    let type = _ref.type;
    return type;
  });
  const size = JSON.stringify([newGame.type, ...currentGameCodes]).length;
  if (size > FAVORITE_MAX_SIZE) {
    svs.eInstant.logger.info("Favorite games size exceeded ".concat(FAVORITE_MAX_SIZE, " , removing oldest favorite game."));
    const newGames = games.slice(0, -1);
    return addFavoriteGameWithSizeLimit(newGames, newGame);
  }
  return [newGame, ...games];
};
const trimFavoriteGamesToSizeLimit = games => {
  const currentGameCodes = games.map(_ref2 => {
    let type = _ref2.type;
    return type;
  });
  const size = JSON.stringify(currentGameCodes).length;
  if (size > FAVORITE_MAX_SIZE) {
    svs.eInstant.logger.info("Favorite games size exceeded ".concat(FAVORITE_MAX_SIZE, " , removing oldest favorite game."));
    const newGames = games.slice(0, -1);
    return trimFavoriteGamesToSizeLimit(newGames);
  }
  return games;
};
const updateFavoriteCategoryGames = (categories, game, remove) => categories.reduce((acc, category) => {
  var _category$gameList2;
  if ((_category$gameList2 = category.gameList) !== null && _category$gameList2 !== void 0 && (_category$gameList2 = _category$gameList2.config) !== null && _category$gameList2 !== void 0 && _category$gameList2.favoriteTickets) {
    if (remove) {
      const newGames = category.games.filter(_ref3 => {
        let type = _ref3.type;
        return type !== game.type;
      });
      category.games = trimFavoriteGamesToSizeLimit(newGames);
    } else {
      category.games = addFavoriteGameWithSizeLimit(category.games, game);
    }
  }
  acc.push(category);
  return acc;
}, []);
const getFavoriteGames = categories => {
  var _categories$find;
  return (categories === null || categories === void 0 || (_categories$find = categories.find(_ref4 => {
    var _gameList$config;
    let gameList = _ref4.gameList;
    return gameList === null || gameList === void 0 || (_gameList$config = gameList.config) === null || _gameList$config === void 0 ? void 0 : _gameList$config.favoriteTickets;
  })) === null || _categories$find === void 0 ? void 0 : _categories$find.games) || [];
};
const ButtonsBlock = _ref5 => {
  var _getFavoriteGames;
  let onPlayClick = _ref5.onPlayClick,
    onDemoClick = _ref5.onDemoClick,
    game = _ref5.game;
  const _svs$eInstant$store = svs.eInstant.store,
    RouterContext = _svs$eInstant$store.RouterContext,
    UPDATE_CATEGORIES = _svs$eInstant$store.actions.UPDATE_CATEGORIES;
  const _useContext = useContext(RouterContext),
    dispatch = _useContext.dispatch,
    categories = _useContext.state.categories;
  const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const favorite = (_getFavoriteGames = getFavoriteGames(categories)) === null || _getFavoriteGames === void 0 ? void 0 : _getFavoriteGames.find(_ref6 => {
    let type = _ref6.type;
    return type === game.type;
  });
  const onFavoriteClick = async () => {
    const currentFavoriteGames = [...getFavoriteGames(categories)];
    const remove = !!favorite;
    try {
      const newCategories = updateFavoriteCategoryGames(categories, game, remove);
      dispatch({
        type: UPDATE_CATEGORIES,
        payload: {
          categories: newCategories
        }
      });
      await svs.eInstant.shared.services.setFavorite(game.type, getFavoriteGames(newCategories), remove);
    } catch (error) {
      dispatch({
        type: UPDATE_CATEGORIES,
        payload: {
          categories: resetFavoriteCategoryGames(categories, currentFavoriteGames)
        }
      });
    }
  };
  if (!isLoggedIn) {
    return React.createElement("div", {
      className: "u-flex u-flex-column tickets-einstant-button-theme"
    }, React.createElement(Button, {
      block: true,
      className: "margin-bottom-1",
      onClick: onPlayClick
    }, "Spela"), React.createElement(Button, {
      block: true,
      className: "margin-bottom-half",
      onClick: onDemoClick,
      transparent: true
    }, "Provspela"));
  }
  return React.createElement("div", {
    className: "u-flex u-flex-column tickets-einstant-button-theme"
  }, React.createElement(Button, {
    block: true,
    className: "margin-bottom-1",
    onClick: onPlayClick
  }, "Spela"), React.createElement("div", {
    className: "u-flex u-flex-row u-flex-justify-content-center einstant-button-block-row-container"
  }, React.createElement(Button, {
    className: "margin-bottom-half einstant-button-block-row-item",
    onClick: onDemoClick,
    transparent: true
  }, "Provspela"), React.createElement(Button, {
    className: "margin-bottom-half einstant-button-block-row-item",
    "data-testid": "tickets-einstant-favorite-btn",
    onClick: onFavoriteClick,
    transparent: true
  }, React.createElement(Icon, {
    icon: favorite ? 'favorites-filled' : 'favorites',
    size: "300"
  }))));
};
setGlobal('svs.eInstant.shared.components.ButtonsBlock', ButtonsBlock);

 })(window);